(function($){
  "use strict";

  const behaviorOptions = {
    name: 'izzyNavbar',
    selector: 'header',
  };

  function behavior(context, settings) {
    $(once(behaviorOptions.name, behaviorOptions.selector, context)).each(function (index, element) {
      $(function() {
        window.izzynNavbar = new IzzyNavbar();
      });
    });
  }

  Drupal.behaviors[behaviorOptions.name] = {
    attach: function(context, settings){
      behavior(context, settings);
    },
  }

  // Init self in case we are loaded async.
  if (jQuery.isReady) {
    // It is up to script to define scope and settings it should be applied to
    // in case of jquery mobile integration used you can use site_common.jquery_mobile.getPageContext()
    // to get only current page's context.
    // In this example we use global scope.
    const context = document;
    const settings = Drupal.settings;
    Drupal.behaviors[behaviorOptions.name].attach(context, settings);
  }

    class IzzyNavbar {
      constructor() {
        this.options = {
          SEL_NAVBAR_MAIN: '.navmain__menu a',
          SEL_NAVBAR_SERVICES: '.navbar__menu a',
          SEL_CLONE_SRC: [
            '.navmain__langs',
            '.navmain__socials',
            '.navmain__contact'
          ],
          SEL_CLONE_TARGET: '#popup-page-main .container',
          CLS_ACTIVE: 'is-active',
        };

        this.cloneMenuMainToPopup();
        this.setLinkActive(this.options.SEL_NAVBAR_MAIN);
        this.setLinkActive(this.options.SEL_NAVBAR_SERVICES);
      }

      setLinkActive(selector) {
        let _links_list = Array.prototype.slice.call( document.querySelectorAll(selector) );
        let _pathname   = location.pathname.replace(/\.html$/,"");

        _links_list.forEach((_link) => {
            _link.classList.remove(this.options.CLS_ACTIVE);
            if( _pathname !== '' && _pathname.indexOf(_link.pathname.replace(/\/$/,"")) >= 0 )
            {
                _link.classList.add(this.options.CLS_ACTIVE);
            }
        });
      }

      cloneMenuMainToPopup() {
        // find target
        let _target_cont = document.querySelector(this.options.SEL_CLONE_TARGET);
        if( !_target_cont ) return;

        for( let x = 0; x < this.options.SEL_CLONE_SRC.length; x++ ) {
            let _selector = this.options.SEL_CLONE_SRC[x];
            let _src_el = document.querySelector(_selector);

            if(_src_el){
              _target_cont && _target_cont.appendChild(_src_el.cloneNode(true));
            }
        }
      }
    }
})(jQuery);
